//イントロ
//---------------------------------------------------------
$(function(){
	const $intro = $('.home-intro');
	const $main = $('.home-main');
	const $scroll = $('.js-scroll');

	// イントロセクションが存在する場合のみoverflow:hiddenを適用
	if ($intro.length > 0) {
		$('html').css({overflow: 'hidden'});
		//PC：マウスホイールイベント
		var mousewheelevent = 'onwheel' in document ? 'wheel' : 'onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll';
		$(document).on(mousewheelevent,function(e){
			var delta = e.originalEvent.deltaY ? -(e.originalEvent.deltaY) : e.originalEvent.wheelDelta ? e.originalEvent.wheelDelta : -(e.originalEvent.detail);
			var windowTop = document.documentElement.scrollTop;

			if (delta < -70 && $intro.hasClass('is-show')){
				$intro.removeClass('is-show');
				$intro.addClass('is-hidden');
				setTimeout(() => {
					$('html').css({overflow: 'auto'});
				}, 1000);
			}else if(delta > 70 && windowTop == 0) {
				$intro.addClass('is-show');
				$intro.removeClass('is-hidden');
				$('html').css({overflow: 'hidden'});
			}
		});

		//スマホ：タッチイベント
		var posiY;

		$intro.on('touchstart', start_check);
		$intro.on('touchmove', move_check_intro);
		$main.on('touchstart', start_check);
		$main.on('touchmove', move_check_main);

		function start_check(e) {
			posiY = getY(e);
		}

		function move_check_intro(e) {
			if (posiY - getY(e) > 100 && $intro.hasClass('is-show')) {
				$intro.removeClass('is-show');
				$intro.addClass('is-hidden');
				setTimeout(() => {
					$('html').css({overflow: 'auto'});
				}, 1000);
			}
		}

		function move_check_main(e) {
			var windowTop = document.documentElement.scrollTop;
			if (posiY - getY(e) < -15 && windowTop == 0) {
				$intro.addClass('is-show');
				$intro.removeClass('is-hidden');
				$('html').css({overflow: 'hidden'});
			}
		}

		function getY(e) {
			return (e.originalEvent.touches[0].pageY);
		}

		//スクロール クリック
		$scroll.on('click',function() {
			$intro.addClass('is-hidden');
			setTimeout(() => {
				$('html').css({overflow: 'auto'});
			}, 1000);
		});


		$(window).on('load' ,function() {
			const maskLine = document.querySelector('.mask-line');

			setTimeout(() => {
				maskLine.classList.add('is-active');
			}, 500);
		});
	}
});

//テキストアニメーション
//---------------------------------------------------------
const slideImg = document.getElementsByClassName('anime-left');
for (let i = 0; i < slideImg.length; i++) {
	gsap.to(slideImg[i], {
		scrollTrigger: {
			trigger: slideImg[i],
			start: 'top 85%',
			toggleClass: {targets: slideImg[i], className: 'is-active'},
			once: true,
		}
	});
}

// menu
//---------------------------------------------------------
function menu() {
	const scrollTop = $(window).scrollTop();
	const $menu = $('.p-menu');
	const targetOffset = $('.home-about').offset().top;

	$menu.css({opacity:0})

	if(scrollTop >= targetOffset) {
		$menu.css({opacity:1},500);
	} else {
		$menu.css({opacity:0},500);
	}
}

$(window).on('load scroll resize orientationchange',() => {
	menu();
});
